import { useContext } from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';

import { CarouselContext } from './CarouselContext';

export default function CarouselControls() {
    const { slides, currentIndex, handleNext, handlePrev } = useContext(CarouselContext);

    return (
        <>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2} sx={{ width: 1, padding: 4 }}>
                <Box
                    sx={{
                        border: 'solid 1px',
                        borderColor: 'common.gray',
                        borderRadius: 5,
                        px: 3,
                        py: 1,
                        width: 'auto',
                        bgcolor: 'common.white',
                        pointerEvents: 'auto'
                    }}
                >
                    <Typography>
                        {currentIndex + 1} / {slides.length}
                    </Typography>
                </Box>
            </Stack>
            {/* Arrows */}
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} sx={{ width: 1, px: 4, display: slides.length > 1 ? '' : 'none' }}>
                <IconButton variant="regular" onClick={handlePrev} sx={{ pointerEvents: 'auto' }}>
                    chevron_left
                </IconButton>
                <IconButton variant="regular" onClick={handleNext} sx={{ pointerEvents: 'auto' }}>
                    chevron_right
                </IconButton>
            </Stack>
        </>
    );
}
